var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNeck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.01,37.33c11.23-2.8,19.55-15.85,19.55-31.07,0-.84-.68-1.51-1.51-1.51s-1.51,.68-1.51,1.51c0,13.87-7.37,25.72-17.31,28.16-.82-1.19-2.19-1.97-3.74-1.97s-2.93,.78-3.74,1.97c-9.95-2.44-17.31-14.27-17.31-28.16,0-.84-.68-1.51-1.51-1.51s-1.51,.68-1.51,1.51c0,15.23,8.32,28.27,19.56,31.07,.11,1.42,.87,2.65,1.97,3.4l-1.5,3.05-6.02,.88c-1.24,.18-1.74,1.71-.84,2.59l4.36,4.25-1.03,6c-.21,1.23,1.08,2.18,2.2,1.6l5.38-2.84,5.39,2.83c1.12,.58,2.4-.35,2.2-1.6l-1.03-6,4.36-4.25c.9-.88,.41-2.4-.84-2.59l-6.02-.88-1.5-3.05c1.11-.74,1.86-1.97,1.97-3.39h0Zm-4.53-1.87c.84,0,1.51,.68,1.51,1.51s-.68,1.51-1.51,1.51-1.51-.68-1.51-1.51,.68-1.51,1.51-1.51Zm6.6,11.75l-2.73,2.66c-.35,.34-.52,.85-.44,1.34l.64,3.76-3.37-1.77c-.44-.24-.97-.24-1.41,0l-3.38,1.77,.64-3.76c.09-.49-.08-1-.44-1.34l-2.73-2.66,3.78-.55c.49-.08,.92-.39,1.14-.83l1.68-3.42,1.68,3.42c.23,.45,.64,.76,1.14,.83l3.78,.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeck);
export default __webpack_public_path__ + "static/media/icon_neck.2393fc39.svg";
export { ForwardRef as ReactComponent };